import { imageUrl } from '@helpers/image';
import { asSlug } from '@helpers/slug';
import SvgArrow from '@img/icons/article-cta-arrow.svg';
import * as React from 'react';
import S from './MediaCard.styles';
const MediaCard = ({ accentColor, content, image, tag, title, url }) => {
    const titleId = asSlug(title);
    return (React.createElement(S.Container, { as: "article", style: { '--accentColor': accentColor } },
        React.createElement(S.Link, { as: url ? 'a' : 'div', ...(url && { href: url, 'aria-label': `Read article: ${title}`, 'title': `Read article: ${title}` }), draggable: false },
            React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { alt: image.altText?.trim() || title, loading: "lazy", src: imageUrl(image, { width: 340, height: 195 }) })),
            React.createElement(S.Tag, null, tag),
            React.createElement(S.Title, { id: titleId }, title),
            content && React.createElement(S.Content, null, content),
            React.createElement(S.CtaWrapper, null,
                React.createElement("span", null, "Read article"),
                React.createElement(SvgArrow, null)))));
};
export default MediaCard;
